import { render } from "./UploadAndRestoreBackup.vue?vue&type=template&id=03570494&ts=true"
import script from "./UploadAndRestoreBackup.ts?vue&type=script&lang=ts&external"
export * from "./UploadAndRestoreBackup.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__